import { alpha, styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';

const PulpyTextField = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(5),
    fontSize: 14,
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 12px',
    width: '100%',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),

    '&:focus': {
      boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}));

export default PulpyTextField;
